"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var dayjs_1 = __importDefault(require("dayjs"));
var formik_1 = require("formik");
var react_1 = __importStar(require("react"));
var DayPickerInput_1 = __importDefault(require("react-day-picker/DayPickerInput"));
require("./DateInput.scss");
var dayjsUtils_1 = __importDefault(require("./dayjsUtils"));
var fromMonth = dayjs_1.default().subtract(120, 'year');
var toMonth = dayjs_1.default();
function YearMonthForm(_a) {
    var date = _a.date, localeUtils = _a.localeUtils, onChange = _a.onChange;
    var months = localeUtils.getMonths();
    var years = [];
    for (var i = fromMonth.year(); i <= toMonth.year(); i += 1) {
        years.push(i);
    }
    var handleChange = function (e) {
        var _a = e.target.form, year = _a.year, month = _a.month;
        var actualMonth = parseInt("" + month.value, 10) + 1;
        onChange(dayjs_1.default(year.value + "-" + actualMonth + "-1", 'YYYY-M-D').toDate());
    };
    return (react_1.default.createElement("form", { className: "DayPicker-Caption" },
        react_1.default.createElement("select", { className: "form-select", name: "month", onChange: handleChange, value: date.getMonth() }, months.map(function (month, i) { return (react_1.default.createElement("option", { key: month, value: i }, month)); })),
        react_1.default.createElement("select", { name: "year", onChange: handleChange, value: date.getFullYear() }, years.map(function (year) { return (react_1.default.createElement("option", { key: year, value: year }, year)); }))));
}
var DateInput = function (props) {
    var _a = formik_1.useField(props), field = _a[0], meta = _a[1], helpers = _a[2];
    var isSubmitting = formik_1.useFormikContext().isSubmitting;
    var _b = react_1.useState(dayjs_1.default().toDate()), month = _b[0], setMonth = _b[1];
    var width = props.width, _c = props.allowSubmittingDisabledState, allowSubmittingDisabledState = _c === void 0 ? true : _c;
    var handleYearMonthChange = react_1.useCallback(function (month) { return setMonth(month); }, []);
    return (react_1.default.createElement(DayPickerInput_1.default, { formatDate: dayjsUtils_1.default.formatDate, parseDate: dayjsUtils_1.default.parseDate, format: "DD/MM/YYYY", placeholder: "DD/MM/YYYY", component: react_1.default.forwardRef(function (props, ref) { return (react_1.default.createElement("input", __assign({}, field, { disabled: isSubmitting && allowSubmittingDisabledState }, props, { ref: ref, className: classnames_1.default('form-input', {
                'form-input--error': !!meta.error,
                'form-input--w-xs': width && width === 'xs',
                'form-input--w-sm': width && width === 'sm',
                'form-input--w-md': width && width === 'md',
                'form-input--w-lg': width && width === 'lg',
            }) }))); }), onDayChange: function (day) {
            if (typeof day === 'undefined') {
                return;
            }
            helpers.setValue(dayjsUtils_1.default.formatDate(day, 'DD/MM/YYYY', 'en-gb'));
        }, value: field.value, dayPickerProps: {
            locale: 'en-gb',
            localeUtils: dayjsUtils_1.default,
            month: month,
            captionElement: function (_a) {
                var date = _a.date, localeUtils = _a.localeUtils;
                return (react_1.default.createElement(YearMonthForm, { date: date, localeUtils: localeUtils, onChange: handleYearMonthChange }));
            },
        } }));
};
exports.default = DateInput;
//# sourceMappingURL=index.js.map